import { DateTimePicker } from '@mantine/dates'

import {
  UseFormReturnType,
} from '@mantine/form'

import {
  DirtyFieldLabel,
  TooltipInfoProps,
} from './dirty-field'

import {
  isFieldDirty,
} from './form-dirty-utils'
import React from 'react'

interface DirtyDateTimePickerProps<
  T extends Record<string, any>
> extends Omit<
  React.ComponentProps<
    typeof DateTimePicker
  >,
  'form' | 'label'
>, TooltipInfoProps {
  form: UseFormReturnType<T>
  field: keyof T
  label: string
}

export function DirtyDateTimePicker<
  T extends Record<string, any>,
>({
    form,
    field,
    label,
    tooltip,
    ...props
  }: DirtyDateTimePickerProps<T>) {
  return (
    <DateTimePicker
      label={
        <DirtyFieldLabel
          label={label}
          tooltip={tooltip}
          changed={isFieldDirty(
            form,
            field,
          )}
        />
      }
      {...form.getInputProps(
        field as string,
      )}
      {...props}
    />
  )
}